// What the web coach sends to the financial-chat function (D-055): the conversation
// with the new question last, and a separate summary of recent transactions on
// every message. Descriptions are left out; the coach needs amounts and categories.

export type ChatTurn = { role: "user" | "assistant"; content: string };

export type CoachContextRow = { type: string; amount: number; category: string; date: string };

const MAX_CONTEXT_ROWS = 30;

type TransactionLike = { type: string; amount: number | string; category: string; date: string };

export function buildChatRequestBody(history: ChatTurn[], question: string, transactions: TransactionLike[]) {
  return {
    messages: [...history, { role: "user" as const, content: question }],
    context: transactions.slice(0, MAX_CONTEXT_ROWS).map<CoachContextRow>((t) => ({
      type: t.type,
      amount: Number(t.amount),
      category: t.category,
      date: t.date,
    })),
  };
}
